import '../../../../node_modules/core-js/modules/es.array.iterator.esm.js';
import '../../../../node_modules/core-js/modules/es.promise.constructor.esm.js';
import '../../../../node_modules/core-js/modules/es.promise.all.esm.js';
import '../../../../node_modules/core-js/modules/es.promise.catch.esm.js';
import '../../../../node_modules/core-js/modules/es.promise.race.esm.js';
import '../../../../node_modules/core-js/modules/es.promise.reject.esm.js';
import '../../../../node_modules/core-js/modules/es.promise.resolve.esm.js';
import '../../../../node_modules/core-js/modules/web.dom-collections.iterator.esm.js';
import { useState, useEffect } from 'react';
import { getAnalytics, Datalayer } from '@mirohq-internal/website-analytics';

async function sendAccountPickerShownEvent() {
  try {
    const analytics = getAnalytics();
    await analytics.sendEvent(new Datalayer('accountPickerShown', {
      openedFrom: 'templates'
    }));
  } catch (e) {
    console.error(e);
  }
}
async function sendAccountSelectedInAccountPickerEvent({
  accountId,
  accountsListIndex,
  workspaceKey
}, callback) {
  try {
    const analytics = getAnalytics();
    await analytics.sendEvent(new Datalayer('accountPickerAccountSelected', {
      accountsListIndex,
      accountId,
      workspaceKey
    }));
    if (callback) {
      callback();
    }
  } catch (e) {
    console.error(e);
  }
}
function useAccountPicker({
  onAccountLoaded,
  onAccountSubmitted,
  onAccountCancel,
  onAccountError
}) {
  const [isAccountPickerVisible, setAccountPickerVisible] = useState(false);
  useEffect(() => {
    if (isAccountPickerVisible) {
      sendAccountPickerShownEvent();
    }
  }, [isAccountPickerVisible]);
  const onAccountPickerLoaded = (accountsIds, workspaceKey) => {
    if (!Array.isArray(accountsIds)) {
      return;
    }
    const accountsLength = accountsIds.length;
    switch (accountsLength) {
      //in application user will use account creation flow
      case 0:
        onAccountLoaded(undefined, workspaceKey);
        break;
      //copy board to single account. no need to select
      case 1:
        onAccountLoaded(accountsIds[0], workspaceKey);
        break;
      //user will select account to copy board
      default:
        setAccountPickerVisible(true);
        break;
    }
  };
  const onAccountPickerSubmit = (accountId, accountsListIndex, workspaceKey) => {
    sendAccountSelectedInAccountPickerEvent({
      accountId,
      accountsListIndex,
      workspaceKey
    }, () => {
      onAccountSubmitted(accountId, workspaceKey);
    });
  };
  const onAccountPickerCancel = () => {
    onAccountCancel();
    setAccountPickerVisible(false);
  };
  return [isAccountPickerVisible, onAccountPickerLoaded, onAccountPickerSubmit, onAccountPickerCancel, onAccountError];
}

export { useAccountPicker };
